<template>
  <div class="order-confirmation d-flex justify-content-center py-5 w-100">
    <b-card
      class="order-form-card bg-white d-flex flex-column align-items-center justify-content-center"
      style="width:600px;"
    >
      <!-- loading -->
      <div v-if="isSubmitting" class="d-flex flex-row">
        <p class="h5 mr-3">Submiting order..</p>
        <b-spinner variant="primary" />
      </div>
      <!-- failed -->
      <div v-if="isFailed" class="d-flex flex-column">
        <div class="d-flex flex-row">
          <p class="h5 mr-3">Failed to submit</p>
          <i class="material-icons text-danger mr-1">clear</i>
        </div>
        <p>please contact sea-way marine..</p>
      </div>
      <!-- loaded -->
      <div v-if="isSubmitted" class>
        <p>Order Number: {{order["number"]}}</p>
        <p>Date: {{date}}</p>
        <b-table striped :items="parts"></b-table>
        <p>Estimated Cost: ${{cost.toFixed(2)}}</p>
        <b-button class="m-2" variant="secondary" @click="print">Print Order</b-button>
        <b-button class="m-2" variant="primary" @click="newOrder">Place Another Order</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { RequestStatus } from "../store/order";
export default {
  computed: {
    order() {
      return this.$store.state.order.order;
    },
    parts() {
      let partsFormattedForTable = Object.keys(
        this.$store.state.order.order.items
      ).map(sku => {
        let part = this.$store.state.order.order.items[sku];
        return {
          partNumber: sku,
          description: part.description,
          orderQuantity: part.orderQuantity,
          dealerPrice: part.dealer_price,
          retailPrice: part.retail_price
        };
      });
      return partsFormattedForTable;
    },
    cost() {
      return this.parts.reduce((acc, cur) => acc + cur.dealerPrice, 0);
    },
    date() {
      return new Date().toLocaleDateString();
    },
    isSubmitting() {
      return this.$store.state.order.submit.status === RequestStatus.Pending;
    },
    isFailed() {
      return this.$store.state.order.submit.status === RequestStatus.Failed;
    },
    isSubmitted() {
      return this.$store.state.order.submit.status === RequestStatus.Success;
    }
  },
  methods: {
    newOrder() {
      this.$router.push("/order");
    },
    print() {
      let printBody = `JEPARTS ORDER
      -----------------------
      Order Number: ${this.order.number}
      Date: ${this.date}
      Note: ${this.order.note}

      Parts:
      `;

      this.parts.forEach(p => {
        printBody += `${p.partNumber} x ${p.orderQuantity}\n`;
      });
      printBody += "-----------------------\n";

      let temporaryWindow = window.open();
      temporaryWindow.document.write(
        `<span style="white-space:pre-line">${printBody}</span>`
      );
      temporaryWindow.print();
      temporaryWindow.close();
    }
  }
};
</script>